import { Alert as AntdAlert } from "@empglabs/backoffice-ui-kit"

const Alert = props => {
  return <AntdAlert {...props} />
}

export default Alert
